import { apiClient } from "shared/api/client";

export const getEvent = async () => {
  try {
    const response = await apiClient.get("/events");
    const data = response.data;
    return data.filter((event) => event.start !== null);
  } catch (error) {
    return [];
  }
};

export const postEvent = async (data) => {
  const response = await apiClient.post("/events", data);
  return response.data;
};

export const updateEvent = async (eventId, data) => {
  const response = await apiClient.patch(`/events/${eventId}`, data);
  return response.data;
};

export const deleteEvent = async (eventId) => {
  const response = await apiClient.delete(`/events/${eventId}`);
  return response.data;
};
